import React, { useMemo, useState } from 'react';
import { Box, Typography, Avatar, Button, Card, CardContent } from '@mui/material';
import CompletedReview from './CompletedReview';
import PersonIcon from '@mui/icons-material/Person';

const ReviewCard = ({ reviewData, onReviewClick, completedReviews = [], isCompletedTab = false }) => {
    const getAvatarColor = (name) => {
        if (!name) return '#daa520';
        return '#daa520';
    };
    
    const { employeeName, employeeAvatar } = reviewData;
    const projects = reviewData.projects || [reviewData];
    const isCompleted = isCompletedTab;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReview, setSelectedReview] = useState(null);

    const taskRatingMap = useMemo(() => {
        const map = {};
        completedReviews.forEach(review => {
            const taskId = review.task?.id || review.id;
            if (taskId) {
                map[taskId] = review.rating;
            }
        });
        return map;
    }, [completedReviews]);

    const renderRatingIcon = (ratingType) => {
        switch (ratingType) {
            case 'two_thumbs_up':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none">
                            <path d="M7.30144 10.85V25.25M16.9837 5.906L15.7734 10.85H22.8294C23.2052 10.85 23.5758 10.9367 23.9119 11.1034C24.248 11.27 24.5404 11.5119 24.7659 11.81C24.9914 12.1081 25.1437 12.4541 25.211 12.8207C25.2782 13.1873 25.2584 13.5643 25.1532 13.922L22.3332 23.522C22.1866 24.0205 21.8808 24.4584 21.4618 24.77C21.0428 25.0816 20.5332 25.25 20.0095 25.25H3.67057C3.0286 25.25 2.41292 24.9971 1.95897 24.5471C1.50502 24.097 1.25 23.4865 1.25 22.85V13.25C1.25 12.6135 1.50502 12.003 1.95897 11.5529C2.41292 11.1029 3.0286 10.85 3.67057 10.85H7.01097C7.4613 10.8498 7.90263 10.725 8.28535 10.4897C8.66806 10.2544 8.97699 9.91786 9.17738 9.518L13.3529 1.25C13.9236 1.25701 14.4854 1.3918 14.9962 1.64432C15.507 1.89683 15.9537 2.26053 16.3028 2.70824C16.652 3.15596 16.8946 3.67611 17.0125 4.22984C17.1304 4.78357 17.1206 5.35656 16.9837 5.906Z"
                                fill="#FFBF00"
                                stroke="#3A3A3A"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none" style={{ marginLeft: '-12px' }}>
                            <path d="M7.30144 10.85V25.25M16.9837 5.906L15.7734 10.85H22.8294C23.2052 10.85 23.5758 10.9367 23.9119 11.1034C24.248 11.27 24.5404 11.5119 24.7659 11.81C24.9914 12.1081 25.1437 12.4541 25.211 12.8207C25.2782 13.1873 25.2584 13.5643 25.1532 13.922L22.3332 23.522C22.1866 24.0205 21.8808 24.4584 21.4618 24.77C21.0428 25.0816 20.5332 25.25 20.0095 25.25H3.67057C3.0286 25.25 2.41292 24.9971 1.95897 24.5471C1.50502 24.097 1.25 23.4865 1.25 22.85V13.25C1.25 12.6135 1.50502 12.003 1.95897 11.5529C2.41292 11.1029 3.0286 10.85 3.67057 10.85H7.01097C7.4613 10.8498 7.90263 10.725 8.28535 10.4897C8.66806 10.2544 8.97699 9.91786 9.17738 9.518L13.3529 1.25C13.9236 1.25701 14.4854 1.3918 14.9962 1.64432C15.507 1.89683 15.9537 2.26053 16.3028 2.70824C16.652 3.15596 16.8946 3.67611 17.0125 4.22984C17.1304 4.78357 17.1206 5.35656 16.9837 5.906Z"
                                fill="#FFBF00"
                                stroke="#3A3A3A"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Box>
                );
            case 'thumbs_up':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none">
                            <path d="M7.30144 10.85V25.25M16.9837 5.906L15.7734 10.85H22.8294C23.2052 10.85 23.5758 10.9367 23.9119 11.1034C24.248 11.27 24.5404 11.5119 24.7659 11.81C24.9914 12.1081 25.1437 12.4541 25.211 12.8207C25.2782 13.1873 25.2584 13.5643 25.1532 13.922L22.3332 23.522C22.1866 24.0205 21.8808 24.4584 21.4618 24.77C21.0428 25.0816 20.5332 25.25 20.0095 25.25H3.67057C3.0286 25.25 2.41292 24.9971 1.95897 24.5471C1.50502 24.097 1.25 23.4865 1.25 22.85V13.25C1.25 12.6135 1.50502 12.003 1.95897 11.5529C2.41292 11.1029 3.0286 10.85 3.67057 10.85H7.01097C7.4613 10.8498 7.90263 10.725 8.28535 10.4897C8.66806 10.2544 8.97699 9.91786 9.17738 9.518L13.3529 1.25C13.9236 1.25701 14.4854 1.3918 14.9962 1.64432C15.507 1.89683 15.9537 2.26053 16.3028 2.70824C16.652 3.15596 16.8946 3.67611 17.0125 4.22984C17.1304 4.78357 17.1206 5.35656 16.9837 5.906Z"
                                fill="#FFBF00"
                                stroke="#3A3A3A"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>
                    </Box>
                );
            case 'thumbs_down':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none">
                            <path d="M7.30144 15.65V1.25M16.9837 20.594L15.7734 15.65H22.8294C23.2052 15.65 23.5758 15.5633 23.9119 15.3966C24.248 15.23 24.5404 14.9881 24.7659 14.69C24.9914 14.3919 25.1437 14.0459 25.211 13.6793C25.2782 13.3127 25.2584 12.9357 25.1532 12.578L22.3332 2.978C22.1866 2.47948 21.8808 2.04157 21.4618 1.73C21.0428 1.41843 20.5332 1.25 20.0095 1.25H3.67057C3.0286 1.25 2.41292 1.50286 1.95897 1.95294C1.50502 2.40303 1.25 3.01348 1.25 3.65V13.25C1.25 13.8865 1.50502 14.497 1.95897 14.9471C2.41292 15.3971 3.0286 15.65 3.67057 15.65H7.01097C7.4613 15.6502 7.90263 15.775 8.28535 16.0103C8.66806 16.2456 8.97699 16.5821 9.17738 16.982L13.3529 25.25C13.9236 25.243 14.4854 25.1082 14.9962 24.8557C15.507 24.6032 15.9537 24.2395 16.3028 23.7918C16.652 23.344 16.8946 22.8239 17.0125 22.2702C17.1304 21.7164 17.1206 21.1434 16.9837 20.594Z"
                                fill="#FAA0A0"
                                stroke="#880808"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round" />
                        </svg>
                    </Box>
                );
            default:
                return null;
        }
    };

    const handleOpenModal = (task) => {
        setSelectedReview({
            taskName: task?.name,
            projectName: task?.rawData?.projectName,
            reviewedById: task?.rawData?.reviewedById,
            reviewedBy: task?.rawData?.employeeName,
            reviewDate: task?.reviewedDate,
            rating: task?.rating,
            feedback: task?.feedback,
            remarks: task?.rawData?.remarks,
            submissionLink: task?.rawData?.submissionLink,
            attachments: task?.rawData?.attachments || [],
        });
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedReview(null);
    };

    return (
        <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
                {/* <Avatar
                    src={employeeAvatar}
                    sx={{ width: 25, height: 25, bgcolor: '#DAA520', fontSize: '12px', p: 0.5 }}
                >
                    {employeeName?.charAt(0)}
                </Avatar> */}
                <Avatar
                    sx={{
                        width: 25,
                        height: 25,
                        bgcolor: getAvatarColor(employeeName),
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        p: employeeAvatar ? 0 : 0.5,
                    }}
                >
                    {employeeAvatar ? (
                        <img
                            src={employeeAvatar}
                            alt={employeeName}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block',
                                borderRadius: '50%',
                            }}
                        />
                    ) : (
                        employeeName?.charAt(0) || <PersonIcon sx={{ fontSize: 14 }} />
                    )}
                </Avatar>
                <Typography variant="body2" fontWeight={500}>
                    {employeeName}
                </Typography>
            </Box>

            <Card sx={{ borderRadius: 2.5 }}>
                <CardContent sx={{
                    p: 2,
                    maxHeight: {
                        xs: '300px',
                        sm: '350px',
                        md: '400px',
                        lg: '500px',
                        xl: '750px',
                    },
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': { width: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#d0d0d0', borderRadius: '3px', '&:hover': { backgroundColor: '#b0b0b0' } }, '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1', borderRadius: '3px' }
                }}>
                    {projects.map((project, projectIndex) => (
                        <Box
                            key={project.id || projectIndex}
                            sx={{
                                border: '1px solid #e5e5e5',
                                backgroundColor: '#F6FBFF',
                                borderRadius: 2,
                                p: 2,
                                mb: projectIndex < projects.length - 1 ? 2 : 0
                            }}
                        >
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#000000' }}>
                                    {project.projectName}
                                </Typography>
                            </Box>

                            {(project.tasks || []).map((task, taskIndex) => {
                                const taskRating = taskRatingMap[task.id];

                                return (
                                    <Box
                                        key={task.id || taskIndex}
                                        mb={taskIndex < (project.tasks || []).length - 1 ? 2 : 0}
                                        sx={{
                                            p: 2,
                                            backgroundColor: '#ffffff',
                                            borderRadius: '8px',
                                            border: '1px solid #E5E5E5'
                                        }}
                                    >
                                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" width="100%">
                                            <Box display="flex" flexDirection="column" gap={0.5}>
                                                <Typography fontSize={14} fontWeight={500} color="text.primary">
                                                    {task.name}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    ({task.count})
                                                </Typography>
                                            </Box>

                                            {isCompleted && taskRating && (
                                                <Box sx={{ ml: 1 }}>
                                                    {renderRatingIcon(taskRating)}
                                                </Box>
                                            )}
                                        </Box>

                                        <Box mt={1.5}>
                                            {isCompleted ? (
                                                task.reviewedDate && (
                                                    <Box>
                                                        <Typography variant="body2" color="text.secondary" mb={2}>
                                                            Reviewed: {task.reviewedDate}
                                                        </Typography>
                                                        <Button
                                                            variant="text"
                                                            onClick={() => handleOpenModal(task)}
                                                            sx={{
                                                                textTransform: 'none',
                                                                color: '#2196F3',
                                                                padding: 0,
                                                                mt: 1,
                                                                width: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: 500,
                                                                '&:hover': {
                                                                    backgroundColor: 'transparent',
                                                                    textDecoration: 'underline'
                                                                }
                                                            }}
                                                        >
                                                            View Submission
                                                        </Button>
                                                    </Box>
                                                )
                                            ) : (
                                                <>
                                                    {task.submittedDate && (
                                                        <Typography variant="body2" color="text.secondary" mb={2}>
                                                            Submitted: {task.submittedDate}
                                                        </Typography>
                                                    )}
                                                    <Button
                                                        variant="text"
                                                        startIcon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                                                                <path d="M14.1668 14.9993C14.6335 14.9993 15.0002 15.366 15.0002 15.8327C15.0002 16.2993 14.6335 16.666 14.1668 16.666C13.7002 16.666 13.3335 16.2993 13.3335 15.8327C13.3335 15.366 13.7002 14.9993 14.1668 14.9993ZM14.1668 12.4993C11.8918 12.4993 9.95016 13.8827 9.16683 15.8327C9.95016 17.7827 11.8918 19.166 14.1668 19.166C16.4418 19.166 18.3835 17.7827 19.1668 15.8327C18.3835 13.8827 16.4418 12.4993 14.1668 12.4993ZM14.1668 17.916C13.6143 17.916 13.0844 17.6965 12.6937 17.3058C12.303 16.9151 12.0835 16.3852 12.0835 15.8327C12.0835 15.2801 12.303 14.7502 12.6937 14.3595C13.0844 13.9688 13.6143 13.7493 14.1668 13.7493C14.7194 13.7493 15.2493 13.9688 15.64 14.3595C16.0307 14.7502 16.2502 15.2801 16.2502 15.8327C16.2502 16.3852 16.0307 16.9151 15.64 17.3058C15.2493 17.6965 14.7194 17.916 14.1668 17.916ZM7.72516 16.666H5.00016V3.33268H10.8335V7.49935H15.0002V10.891C15.5835 10.9577 16.1335 11.0993 16.6668 11.2993V6.66602L11.6668 1.66602H5.00016C4.55814 1.66602 4.13421 1.84161 3.82165 2.15417C3.50909 2.46673 3.3335 2.89065 3.3335 3.33268V16.666C3.3335 17.108 3.50909 17.532 3.82165 17.8445C4.13421 18.1571 4.55814 18.3327 5.00016 18.3327H8.75016C8.33032 17.8292 7.98511 17.2679 7.72516 16.666Z" fill="#2196F3" />
                                                            </svg>}
                                                        onClick={() => onReviewClick({
                                                            ...project,
                                                            selectedTask: {
                                                                name: task.name,
                                                                id: task.id,
                                                                count: task.count,
                                                                submittedDate: task.submittedDate,
                                                                rawData: task.rawData
                                                            },
                                                            selectedTaskIndex: taskIndex
                                                        })}
                                                        sx={{
                                                            textTransform: 'none',
                                                            color: '#2196F3',
                                                            padding: 0,
                                                            width: '100%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            '&:hover': {
                                                                backgroundColor: 'transparent',
                                                                textDecoration: 'underline'
                                                            }
                                                        }}
                                                    >
                                                        Review Now
                                                    </Button>
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    ))}
                    {/* Completed Review Modal */}
                    <CompletedReview
                        open={isModalOpen}
                        onClose={handleCloseModal}
                        reviewData={selectedReview}
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

export default ReviewCard;